import React from 'react';
import { motion } from 'framer-motion';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  icon?: React.ReactNode;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, label, icon }) => {
  return (
    <label className="flex items-center cursor-pointer select-none gap-3">
      {icon && <span className="text-red-500">{icon}</span>}
      {label && <span className="text-white/70 text-sm">{label}</span>}
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={`w-11 h-6 rounded-full transition-colors duration-300 ${checked ? 'bg-red-500 shadow-lg shadow-red-500/30 border border-red-400' : 'bg-gray-400 border border-gray-300'}`}
        ></div>
        <motion.div
          className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow-md`}
          animate={{ x: checked ? 20 : 0 }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        />
      </div>
    </label>
  );
};

export default ToggleSwitch; 